// True specifically for the packaged Electron or Tauri desktop build — not
// for an installed PWA, which counts as "standalone" (see isStandaloneApp)
// but still runs in a regular browser engine with no bundled local files.
export function isDesktopShell() {
  const isElectron = /Electron/i.test(window.navigator.userAgent)
  const isTauri = typeof window.__TAURI_INTERNALS__ !== "undefined"

  return isElectron || isTauri
}
